import {
  TextField, Typography,
} from "@king-ict/eupisi-ui/components";
import { useInput } from "@king-ict/eupisi-ui/hooks";
import { nameof } from "@king-ict/eupisi-ui/utils";
import { Button, Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { Beneficiary, BeneficiaryFilter, beneficiaryInitial } from "../../models";
import styles from "./BeneficiaryListSearchFilters.module.scss";

export interface BeneficiaryListSearchFiltersProps {
  handleSearch: any;
  setFilters: (value: React.SetStateAction<BeneficiaryFilter>) => void;
  filters: BeneficiaryFilter;
  handleClear?: () => void;
}

export const BeneficiaryListSearchFilters = ({
  handleSearch,
  setFilters,
  filters,  
  handleClear = () => {
    setFilters((prev) => {
      return {
        beneficiaryInitial
      } as unknown as Beneficiary;
    });
  },
}: BeneficiaryListSearchFiltersProps) => {
  // const user = useTypedSelector((state) => state.application.user);

  const { t } = useTranslation();

  const { handleChange } = useInput();

  return (
    <>
      <Row className={styles.filterRow}>
        <Col md={6}>
          <TextField
            label={t("beneficiary.firstName")}
            name={nameof<typeof filters>("firstName")}
            value={filters.firstName}
            onChange={(e: any) => handleChange(e, setFilters)}
          />
        </Col>
        <Col md={6}>
          <TextField
            label={t("beneficiary.lastName")}
            name={nameof<typeof filters>("lastName")}
            value={filters.lastName}
            onChange={(e: any) => handleChange(e, setFilters)}
          />
        </Col>
      </Row>
      <Row className={styles.filterRow}>
        <Col md={6}>
          <TextField
            label={t("beneficiary.oib")}
            name={nameof<typeof filters>("oib")}
            value={filters.oib}
            onChange={(e: any) => handleChange(e, setFilters)}
          />
        </Col>
        <Col md={6}>
          <TextField
            label={t("common.role")}
            name={nameof<typeof filters>("roleName")}
            value={filters.roleName}
            onChange={(e: any) => handleChange(e, setFilters)}
          />
        </Col>
      </Row>
      <Row className={styles.filterRow}>
        <Col md={6}>
          <TextField
            label={t("common.kindergaten")}
            name={nameof<typeof filters>("institutionName")}
            value={filters.institutionName}
            onChange={(e: any) => handleChange(e, setFilters)}
          />
        </Col>
        <Col md={6}>
          <TextField
            label={t("beneficiary.kindergatenOIB")}
            name={nameof<typeof filters>("InstitutionOIB")}
            value={filters.InstitutionOIB}
            onChange={(e: any) => handleChange(e, setFilters)}
          />
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <div className={styles.searchButtons}>
            <Button color="primary" onClick={handleSearch}>
              {t("common.search")}
            </Button>
            <Typography color="primary" onClick={handleClear}>
              {t("common.clearFilters")}
            </Typography>
          </div>
        </Col>
      </Row>
    </>
  );
};
